export const genderType = [
    {
        name: 'Masculino',
        value: 'MALE'
    },
    {
        name: 'Femenino',
        value: 'FEMALE'
    }
];